import styled from "styled-components";
// Path assumes this file lives at
// src/components/sections/WelcomeScreen/MealSchedule/MealScheduleStep.styles.js
import { DIET_C } from "../../../common/colors";

// ═══════════════════════════════════════════════════════════════════════════════
// MEAL SCHEDULE STEP
// Reuses the --c-*/--sp-*/--r-sm/--t-fast custom properties that
// AssessmentStepShell.styles.js's <Section> scopes over the whole step —
// this file never redeclares them, same as FoodPreferencesStep.styles.js.
// ═══════════════════════════════════════════════════════════════════════════════

export const FieldGroup = styled.div`
  margin-bottom: var(--sp-6);
`;
FieldGroup.displayName = "FieldGroup";

export const FieldLabel = styled.label`
  display: block;
  color: var(--c-text);
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: var(--sp-2);
`;
FieldLabel.displayName = "FieldLabel";

export const RequiredMark = styled.span`
  color: ${DIET_C.accent};
  margin-left: 2px;
`;
RequiredMark.displayName = "RequiredMark";

export const HelperValue = styled.span`
  color: var(--c-text-muted);
  font-weight: 500;
`;
HelperValue.displayName = "HelperValue";

export const ErrorText = styled.p`
  color: ${DIET_C.accent};
  font-size: 0.8rem;
  font-weight: 600;
  margin: var(--sp-1) 0 0;
`;
ErrorText.displayName = "ErrorText";

// ─── Breakfast/Lunch/Dinner/Bedtime — time picker grid ──────────────────────
export const TimeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--sp-4);

  @media (max-width: 30em) {
    grid-template-columns: 1fr;
  }
`;
TimeGrid.displayName = "TimeGrid";

export const TimeField = styled.div``;
TimeField.displayName = "TimeField";

export const TimeInput = styled.input.attrs({ type: "time" })`
  width: 100%;
  height: 44px;
  padding: 0 var(--sp-3);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.92rem;
  border: 1px solid ${({ $error }) => ($error ? DIET_C.accent : `${DIET_C.secondary}88`)};
  transition: border-color var(--t-fast);

  &:focus-visible {
    outline: none;
    border-color: ${DIET_C.primary};
  }
`;
TimeInput.displayName = "TimeInput";

// ─── Number of Meals / Fasting Window — dropdowns ───────────────────────────
export const SelectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--sp-4);

  @media (max-width: 30em) {
    grid-template-columns: 1fr;
  }
`;
SelectGrid.displayName = "SelectGrid";

export const Select = styled.select`
  width: 100%;
  height: 44px;
  padding: 0 var(--sp-3);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.92rem;
  border: 1px solid ${DIET_C.secondary}88;
  transition: border-color var(--t-fast);

  &:focus-visible {
    outline: none;
    border-color: ${DIET_C.primary};
  }
`;
Select.displayName = "Select";
